import React, { useState } from "react";
import Slider from "react-slick";
import { Container } from "react-bootstrap";
import moment from "moment";
import "./EventCarousel.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const EventsCarousel = ({ previousData }) => {
  const [searchTerm, setSearchTerm] = useState("");

  // Dynamically map previousData.events
  const eventData = (previousData?.events || []).map((event) => ({
    title: event.event_name || "Untitled Event",
    start: event.event_start_time
      ? moment(event.event_start_time + "Z").format("YYYY-MM-DD HH:mm")
      : "N/A",
    end: event.event_end_time
      ? moment(event.event_end_time + "Z").format("YYYY-MM-DD HH:mm")
      : "N/A",
    description: event.event_description || "<i>No description</i>",
  }));

  // Filtered list based on search input
  const filteredEvents = eventData.filter((event) =>
    event.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Container fluid>
      <div className="col-12 col-xl-12">
        {/* Header */}
        <div className="d-flex align-items-center gap-5 mb-4">
          <h2 className="font-18 font-weight-bold heading-color mb-0">
            Sequence of Events:
          </h2>

          {/* Search Filter */}
          <div className="position-relative" style={{ maxWidth: "300px" }}>
            <input
              placeholder="Search..."
              className="form-control border-0 bg-transparent ps-5 text-color font-13 font-weight-normal"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <img
              alt="Search"
              width="16"
              height="16"
              className="position-absolute"
              src="/assets/images/search-icon.svg"
              style={{
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                pointerEvents: "none",
              }}
            />
          </div>
        </div>

        {/* Slider */}
        <Slider {...settings}>
          {filteredEvents.length > 0 ? (
            filteredEvents.map((event, index) => (
              <div key={index} className="px-2">
                <div className="card event-card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h3 className="font-13 font-weight-medium heading-color mb-2">
                          Event Name:
                        </h3>
                        <p className="font-13 font-weight-normal text-color mb-0">
                          {event.title}
                        </p>
                      </div>
                      {/* <button className="bg-transparent border-0">
                        <img
                          src="/assets/images/expand-icon.svg"
                          alt="expand"
                        />
                      </button> */}
                    </div>
                    <div className="d-flex justify-content-between mb-3">
                      <div>
                        <h3 className="font-13 font-weight-medium heading-color mb-2">
                          Start Time:
                        </h3>
                        <p className="font-13 font-weight-normal text-color mb-0">
                          {event.start} {previousData.incident_timezone || ""}
                        </p>
                      </div>
                      <div>
                        <h3 className="font-13 font-weight-medium heading-color mb-2">
                          Completion Time:
                        </h3>
                        <p className="font-13 font-weight-normal text-color mb-0">
                          {event.end}
                        </p>
                      </div>
                    </div>
                    <div>
                      <h3 className="font-13 font-weight-medium heading-color mb-2">
                        Description:
                      </h3>
                      <p
                        className="font-13 font-weight-normal text-color mb-0 text-truncate"
                        dangerouslySetInnerHTML={{
                          __html: event.description,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-muted px-3">No events match your search.</div>
          )}
        </Slider>
      </div>
    </Container>
  );
};

export default EventsCarousel;